import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import type { PriceWrite, Promotion } from '@/types/pricing';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

/** Only what changed: kitchensink binds the body over the stored row, so an unchanged date sent back could undo a newer one. */
export type PromotionPatch = { price?: PriceWrite; date_start?: string; date_end?: string };

export const patchPromotion = async (
  scope: RequestScope,
  { itemId, id, data }: { itemId: number; id: number; data: PromotionPatch },
  options: WriteRequestOptions
): Promise<EndpointResponse<Promotion>> => {
  try {
    const response = await scopedApi(scope).patch<EndpointResponse<Promotion>>(`pricing_item/${itemId}/promotion/${id}`, data, options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error, { redactRequestData: true });
  }
};
